module.exports = __webpack_public_path__ + "img/genIdentity.4a0cab04.svg";